export function fetchNavigationData(url) {
  /**
   * The ID for the navigation enpoint is the context url + @navigation.
   */
  const navigationId = `${url}/@navigation`;

  /**
   * Default headers we need to provide to access the Plone API.
   */
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  /**
   * Perform the API call.
   *
   */
  return fetch(navigationId, { headers });
}
